import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Alert, Typography, Box, Chip,
} from '@mui/material';
import { apiService } from '../services/apiService';

const severityMap = {
  info: 'info',
  warning: 'warning',
  critical: 'error',
};

const MotdDialog = ({ open, onClose, motd, onAcknowledged }) => {
  const [loading, setLoading] = useState(false);

  if (!motd) return null;

  const handleAcknowledge = async () => {
    setLoading(true);
    try {
      // Resolve observatory_id — could be object, string, or on a different key
      const obsId = motd.observatory_id?._id || motd.observatory_id || motd.observatoryId;
      if (obsId) {
        await apiService.acknowledgeMotd(obsId, motd._id);
      } else {
        // System MOTD — use system acknowledge endpoint
        await apiService.acknowledgeSystemMotd(motd._id);
      }
      onAcknowledged?.(motd._id);
      onClose();
    } catch (err) {
      console.error('Failed to acknowledge MOTD:', err);
    } finally {
      setLoading(false);
    }
  };

  const isExpired = new Date(motd.expires_at) < new Date();
  const severity = severityMap[motd.severity] || 'info';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {motd.title}
        <Chip
          label={motd.severity}
          color={severity}
          size="small"
          sx={{ ml: 1 }}
        />
        {isExpired && <Chip label="Expired" size="small" variant="outlined" />}
      </DialogTitle>
      <DialogContent>
        <Alert severity={severity} sx={{ mb: 2 }}>
          {motd.message}
        </Alert>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          {motd.created_by && (
            <Typography variant="caption" color="text.secondary">
              By: {motd.created_by.first_name} {motd.created_by.last_name}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            Expires: {new Date(motd.expires_at).toLocaleString()}
          </Typography>
          {motd.delivery_type && motd.delivery_type !== 'message' && (
            <Chip label={`Sent via ${motd.delivery_type}`} size="small" variant="outlined" />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={handleAcknowledge}
          variant="contained"
          disabled={loading}
        >
          {loading ? 'Acknowledging...' : 'I Acknowledge'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MotdDialog;
